import { Injectable } from '@angular/core';
import { ToastController, AlertController, LoadingController, NavController, ActionSheetController, ModalController } from '@ionic/angular';
import { AlertButton, AlertInput, ActionSheetButton } from '@ionic/core';
import { ChangePasswordComponent } from '../modules/components/change-password/change-password.component';


@Injectable({
  providedIn: 'root'
})
export class CommonMessageService {

  constructor(public toastController: ToastController,
    public alertController: AlertController,
    private nav: NavController,
    private actionSheetController: ActionSheetController,
    public loadingController: LoadingController,
    private modalController: ModalController
    ) { }

  async toast(message, duration = 2500, closeButton = '', color = 'default', position: 'top' | 'bottom' | 'middle' = 'top') {
    if (!message) {
      return;
    }
    const toast = await this.toastController.create({
      message: message,
      duration,
      buttons: closeButton ? [
        {
          side: 'end',
          text: closeButton,
          icon: 'close',
          role: 'cancel'
        }
      ] : [],
      animated: true,
      color,
      cssClass: color,
      mode: 'ios',
      position,
      id: '' + new Date().getTime()
    });
    toast.present();
    return toast;
  }
  async errorToast(message?: string, duration = 5000, closeButton = 'Fermer') {
    return this.toast(message, duration, closeButton, 'danger', 'top');
  }
  async successToast(message, duration = 5000, closeButton = 'Fermer') {
    return this.toast(message, duration, closeButton, 'success');
  }
  async warningToast(message, duration = 5000, closeButton = 'Fermer') {
    return this.toast(message, duration, closeButton, 'warning');
  }

  async sheet(buttons: (ActionSheetButton | string)[], header: string, subHeader?: string, translucent = false, mode?: 'md' | 'ios') {
    const action = await this.actionSheetController.create({
      buttons,
      animated: true,
      backdropDismiss: true,
      keyboardClose: true,
      header,
      mode,
      subHeader,
      translucent
    });
    action.present();
    return action;
  }
  async alert(message, title, subTitle, buttons: (AlertButton | string)[] = ['Ok'], inputs: AlertInput[] = []) {
    const alert = await this.alertController.create({
      header: title,
      subHeader: subTitle,
      message: message,
      buttons,
      inputs,
      backdropDismiss: false
    });
    await alert.present();
    return alert;
  }
  async confirmAlert(message: string, title?: string, subTitle?: string) {
    return new Promise(async (resolve) => {
      const alert = await this.alert(message, title || '', subTitle || '', [
        {
          text: 'Annuler',
          role: 'cancel',
          handler: () => resolve(false)
        },
        {
          text: 'Valider',
          handler: () => resolve(true)
        }
      ]);
    });
  }
  async loading(message, duration = -1) {
    const loading = await this.loadingController.create({
      message: message,
      cssClass: 'primary',
      animated: true,
      mode: 'ios',
      spinner: 'circular',
    });
    if (duration > 0) {
      loading.duration = duration;
    }
    await loading.present();
    return loading;
  }


  pleaseWaitLoading() {
    return this.loading('Veuillez patienter un instant.');
  }

  back() {
    this.nav.back();
  }

  async changePassword() {
    const dismissible = {value: false};
    const modal = await this.modalController.create({
      component: ChangePasswordComponent,
      componentProps: {
        dismissible,
      },
      mode: 'ios',
      swipeToClose: false,
      showBackdrop: true,
      backdropDismiss: true,
      canDismiss: async () => dismissible.value,
      keyboardClose: true,
    });
    modal.present();

    const { data } = await modal.onDidDismiss();

  }
}
